import { Form } from 'react-bootstrap'
import * as React from 'react'
import ErrorText from '../ErrorText'
import { InputHTMLAttributes } from 'react'

export interface SelectFieldOption {
  label: string
  value: string
}

type SelectFieldTypes = InputHTMLAttributes<HTMLSelectElement>

export type SelectFieldProps = {
  label?: string
  value?: string | number
  errorMessage?: string
  emptyOptionText?: string
  options: SelectFieldOption[]
} & Omit<SelectFieldTypes, 'size' | 'value'>

export const SelectField = ({
  label,
  errorMessage,
  options,
  emptyOptionText,
  ...other
}: SelectFieldProps) => {
  return (
    <Form.Group>
      {label && (
        <Form.Label>
          <strong>{label}</strong>
        </Form.Label>
      )}
      <Form.Control isInvalid={!!errorMessage} as="select" {...other}>
        {emptyOptionText && (
          <option value="" disabled>
            {emptyOptionText}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Control>

      {errorMessage && <ErrorText text={errorMessage} />}
    </Form.Group>
  )
}
